export const data = {
	data() {
		return {
			headerList: [
				// {
				// 	prop: 'id',
				// 	label: '序号'
				// },
				{
					prop: 'marketing',
					label: '参与课程',
					width: 200
				},
				{
					prop: 'active_pattern',
					label: '秒杀模式',
					width: 100
				},
				{
					prop: 'price',
					label: '秒杀价格',
					width: 100
				},
				{
					prop: 'times',
					label: '活动时间',
					width: 180
				},
				{
					prop: 'process',
					label: '秒杀进度',
					width: 100
				},
				{
					prop: 'num_limit',
					label: '参与人数',
					width: 100
				},
				{
					prop: 'status_desc',
					label: '状态',
					width: 100
				},
				// {
				// 	prop: 'created_time',
				// 	label: '活动时间'
				// }
			]
		}
	}
}